import {createHtmlElementFromHtml} from "../../lib/domFunctions";
import {AliveList, AliveListMode} from "../AliveList";
import {DashboardWidget, DashboardWidgetContext} from "./DashboardWidget";

const TEMPLATE = `
<div class="dashboard-widgets__alive-body p-2">
	<div class="p-2 pb-0" data-bind="listAlive"></div>
</div>
`;

export class AliveListWidget implements DashboardWidget {
	static readonly WAITING_ID = 'alive-waiting-list'
	static readonly WORKING_ID = 'alive-working-list'

	readonly id: string
	readonly element: HTMLElement

	private readonly list: AliveList

	constructor(context: DashboardWidgetContext, content: HTMLElement, mode: AliveListMode) {
		this.id = mode == 'waiting' ? AliveListWidget.WAITING_ID : AliveListWidget.WORKING_ID
		this.element = createHtmlElementFromHtml(`<div class="dashboard-widgets__alive">${TEMPLATE}</div>`)
		content.append(this.element)

		this.list = new AliveList(this.element, context.schemaState, context.playerData, mode)
	}

	reset() {
		this.list.reset()
	}

	dispose() {
		this.list.dispose()
	}
}
